export enum FormFooterConstants {
  EncryptedConnection = 'Bezpieczny\nzakup',
  OfferFromTU = 'Popularnych\nUbezpieczycieli',
}
